var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid row",staticStyle:{"padding":"30px","background-color":"white"}},[_c('apexchart',{attrs:{"width":"500","type":"pie","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }